<div class="flex flex-col w-full">
    <div class="p-3">
        <app-table-filter [searchForm]="searchForm" (stringResult)="onSelectedString($event)"
            class="text-primary"></app-table-filter>
    </div>

    <ng-container *ngIf="selectedWellString">
        <!-- <div role="tablist" class="tabs tabs-lifted w-fit">
            <a *ngFor="let tab of tabs" role="tab" [ngClass]="{
                'tab w-fit': true, 
                'custom-active-tab': router.url.includes(tab.route),
                'custom-inactive-tab': !router.url.includes(tab.route), 
            }" (click)="onSelectedTab(tab.route)">{{tab.name}}</a>
        </div> -->

        <div role="tablist" class="tabs tabs-lifted">
            <a *ngFor="let tab of tabs" role="tab" [innerHTML]="formatTabName(tab.name)" [ngClass]="{
                    'tab h-14  whitespace-nowrap overflow-hidden text-ellipsis': true,
                    'custom-active-tab': this.router.url.split('/')[4] === tab.route,
                    'custom-inactive-tab': this.router.url.split('/')[4] !== tab.route,
                    'w-48': tab.route == 'trscssv-wrsv',
                }" (click)="onSelectedTab(tab.route)">
                {{ tab.name }}
            </a>
        </div>

        <!-- <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onSelectedTabChange($event)">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.name"></mat-tab>
        </mat-tab-group> -->

        <!-- <mat-button-toggle-group class="custom-toggle-group mb-6 justify-center"  [value]="selectedTab" (change)="onToggleChange($event)">
            <mat-button-toggle *ngFor="let tab of tabs; let i = index; let last = last" [value]="tab" class="truncate" [ngClass]="{
                'row-1': i === 0,
                'row-2': i > 0 && i < 7,
                'row-3': i >= 7 && i <= 10,
                'row-4' : i == 11
              }">
                <div [ngClass]="{ 'text-gray-600' : selectedTab != tab, 'text-primary font-bold' : selectedTab == tab }">{{ tab.name }} </div>
            </mat-button-toggle>
        </mat-button-toggle-group> -->

        <router-outlet></router-outlet>
    </ng-container>

    <ng-container *ngIf="!selectedWellString">
        <div
            class="flex items-center justify-center border-2 border-gray-300 rounded-md bg-gray-100 short:min-h-96  min-h-[60vh] text-lg font-bold">
            Please Select any Well String to view Equipment Registration
        </div>
    </ng-container>

</div>